import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-match-summary',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-match-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonMatchSummaryComponent { }
